// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { isEmptyOrUndefined } from "@flip/XDL/Utilities";
import { FormField, FormState } from "@flip/XDL/Utilities/form";
import { maxLengthAttr } from "@flip/XDL/Utilities/validation";
import translate from "@insite/client-framework/Translate";

export interface QuoteFormState extends FormState {
    fields: {
        firstName: FormField<string>;
        lastName: FormField<string>;
        email: FormField<string>;
        company: FormField<string>;
        phone: FormField<string>;
        manufacturer: FormField<string>;
        partNumber: FormField<string>;
        quantity: FormField<string>;
        targetPrice: FormField<string>;
        message: FormField<string>;
        file: FormField<any>;
    };
}

export const initialQuoteFormState: QuoteFormState = {
    isValid: false,
    isSubmitted: false,
    fields: {
        firstName: {
            value: "",
            attrs: {
                id: "requestQuote_firstName",
                name: "firstName",
                label: translate("First Name"),
                placeholder: translate("Your First Name"),
                required: true,
                type: "firstName",
            },
        },
        lastName: {
            value: "",
            attrs: {
                id: "requestQuote_lastName",
                name: "lastName",
                label: translate("Last Name"),
                placeholder: translate("Your Last Name"),
                required: true,
                type: "lastName"
            },
        },
        email: {
            value: "",
            attrs: {
                type: "email",
                name: "email",
                id: "requestQuote_email",
                label: translate("Email Address"),
                placeholder: translate("Your Email"),
                required: true,
            },
        },
        phone: {
            value: "",
            attrs: {
                id: "requestQuote_phoneNumber",
                name: "phone",
                label: translate("Phone Number"),
                placeholder: "( ___ ) ___ - ____",
                required: true,
                type: "phone",
            },
        },
        company: {
            value: "",
            attrs: {
                id: "requestQuote_companyName",
                name: "company",
                label: translate("Company Name"),
                placeholder: translate("Your Company Name"),
                required: true,
                maxLength: maxLengthAttr.companyName,
            },
        },
        manufacturer: {
            value: "",
            attrs: {
                id: "requestQuote_Manufacturer",
                name: "manufacturer",
                label: translate("Manufacturer"),
                placeholder: translate("Manufacturer"),
                maxLength: maxLengthAttr.manufacturer,
                required: true,
            },
        },
        partNumber: {
            value: "",
            attrs: {
                id: "requestQuote_partNumber",
                name: "partNumber",
                label: translate("Manufacturer Part Number"),
                placeholder: translate("Manufacturer Part Number"),
                maxLength: maxLengthAttr.postalCode,
                required: true,
            },
        },
        quantity: {
            value: "",
            attrs: {
                id: "requestQuote_quantity",
                name: "quantity",
                label: translate("Quantity"),
                placeholder: translate("Quantity"),
                type: "qty",
                required: true,
            },
        },
        targetPrice: {
            value: "",
            attrs: {
                id: "requestQuote_targetPrice",
                name: "targetPrice",
                label: translate("Target Price"),
                placeholder: translate("Target Price"),
                required: true,
            },
        },
        message: {
            value: "",
            attrs: {
                id: "requestQuote_notes",
                name: "message",
                label: translate("Message"),
                placeholder: translate("Message"),
                type: "note",
                maxLength: 300
            },
        },
        file: {
            value: null,
            attrs: {
                name: "file",
                type: "file",
                label: translate("Upload File"),
            },
        },
    },
};
